export const checkInventory = (objectId, callback) => {
    fetch(`/giftshop/inventory/${objectId}`, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      callback(data);
    });
}

export const getItem = (objectId, callback) => {
  fetch(`/giftshop/item/${objectId}`, {
  method: "GET", // *GET, POST, PUT, DELETE, etc.
})
  .then((response) => response.json())
  .then((data) => {
    console.log(data);
    callback(data);
  });
}